import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import UserResourcesManager from '@/components/UserResourcesManager';
import { flows } from '@/helpers/APIconnection';
import { NotificationsController } from '@/views/NotificationsDashboard';
import { FlowsController } from '@/views/FlowsPanel';
import { AltasBajasController } from '@/views/Asesoria/AltasBajasDashboard';
import FIEController from '@/helpers/fie-controller.js';
import store from '@/store';
export const LocalFlows = {
  'get-fie-siltra': {
    title: 'Obtener archivos FIE desde SILTRA',
    localFlow: FIEController.GetFieFromSILTRA,
    automationResponse: () => {
      store.state.FIE_RemoteUpdate?.();
    }
  },
  'sync-fie-a3': {
    title: 'Sincronización de movimientos FIE en A3',
    localFlow: FIEController.SyncA3,
    automationResponse: () => {
      store.state.FIE_RemoteUpdate?.();
    }
  },
  'sync-siltra-a3': {
    title: 'Sincronizar en A3 los FIEs obtenidos desde SILTRA',
    localFlow: FIEController.SyncSILTRAA3,
    automationResponse: () => {
      store.state.FIE_RemoteUpdate?.();
    }
  },
  'sync-altas': {
    title: 'Sincronizar formularios de Alta en Sistema Red',
    localFlow: AltasBajasController.SyncSubmissions
  },
  'sync-altas-a3': {
    title: 'Sincronizar formularios de Alta en A3',
    localFlow: AltasBajasController.SyncSubmissionsToA3
  }
};
export default {
  data: function () {
    return {
      open: false,
      loading: {},
      refreshInterval: 20,
      modalSlots: {
        activeSlot: 'modal',
        modal: {
          raw: true,
          bully: false,
          onclick: () => this.$cancelableTimeout(this, 'dblclick-autopilot', 200, () => this.$createToastMessage({
            text: 'Haz doble click fuera para salir',
            type: 'secondary',
            close: false,
            fixed: true,
            alive: 2000
          })),
          ondblclick: () => {
            this.$cancelableTimeout(this, 'dblclick-autopilot', 1000);
            this.open = false;
          }
        }
      },
      apps: {
        general: {
          title: 'Activar / Desactivar todas',
          icon: 'icon-desktop',
          isApp: false,
          enabled: true
        },
        robots: {
          title: 'Robots para asesorías',
          description: 'Robots para asesorías y lanzamientos remotos',
          icon: 'icon-flow',
          automation: true,
          enabled: true,
          onActive: this.GetFlowSchedules,
          onUpdate: this.GetFlowSchedules
        },
        altasbajas: {
          title: 'Altas desasistidas',
          description: 'Gestión de solicitudes de altas desasistidas',
          image: require('@/assets/icons/altasbajas.svg'),
          automationID: 'altasbajas-automation',
          automation: true,
          certsConfig: {
            multiple: false
          },
          onActive: this.GetAltasBajasForms,
          onUpdate: this.GetAltasBajasForms
        },
        notifications: {
          title: 'Notificaciones',
          description: 'Comprobación de nuevas notificaciones en DEHÚ',
          icon: 'icon-bell',
          automationID: 'notifications-automation',
          automation: true,
          onActive: this.GetNotificationsSchedules,
          onUpdate: this.GetNotificationsSchedules,
          certsConfig: {
            multiple: true
          }
        }
      },
      tasks: {},
      executionTimer: this.$timer({
        interval: 3,
        callback: this.LaunchNextActiveTask,
        autoRestart: true
      }),
      executionInProgress: false,
      // Active flow launching

      today: undefined
    };
  },
  async created() {
    if (localStorage.getItem('is-autopilot-open')) {
      this.open = true;
    }
    const appLocalStatus = this.$userLocalStorage.get('autopilot-appLocalStatus');
    if (appLocalStatus) {
      const appLocalStatusParsed = JSON.parse(appLocalStatus);
      for (const key in appLocalStatusParsed) {
        const currentValue = appLocalStatusParsed[key];
        if (currentValue.certificates) {
          this.apps[key].certificates = currentValue.certificates;
          this.apps[key].normalizedCertificates = await UserResourcesManager.methods.SerialNumberToCerts(currentValue.certificates);
        }
        if (currentValue.enabled) {
          this.EnableApp(this.apps[key]);
        }
      }
    }
    store.state.AutopilotGetSchedulesNow = () => {
      if (this.apps.robots.active) {
        this.apps.robots.timer?.trigger();
      }
    };
    const getToday = () => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      this.today = today.getTime();
    };
    getToday();
    this.todayInterval = setInterval(getToday, 1000);
    if (this.ReadonlyMode) {
      this.apps.robots.enabled = true;
    }
  },
  unmounted() {
    this.Apps?.forEach(app => app.timer?.stop());
    this.executionTimer.stop();
    clearInterval(this.todayInterval);
  },
  computed: {
    ButtonBinding() {
      return store.state.externalAccess = {
        text: this.ReadonlyMode ? 'Robots programados' : 'Piloto automático',
        icon: this.open ? 'icon-cross text-2xs! flex items-center justify-center' : 'icon-mr-robot text-lg',
        onclick: () => this.open = !this.open
      };
    },
    ReadonlyMode() {
      return !this.$embedded;
    },
    Apps() {
      return Object.values(this.apps).filter(app => app.automation);
    },
    ActivesApp() {
      return this.Apps.filter(app => {
        const active = this.apps.general.enabled && app.enabled && (!app.certsConfig || !!app.certificates?.length);
        if (!app.active && active && app.onActive) {
          if (app.onActive) {
            app.onActive();
          }
          if (app.onUpdate) {
            if (!app.timer) {
              app.timer = this.$timer({
                interval: this.refreshInterval,
                callback: app.onUpdate,
                autoRestart: true
              });
            }
            app.timer.start();
          }
        }
        if (app.active && !active) {
          app.timer?.stop();
        }
        return app.active = active;
      });
    },
    SomeActiveApp() {
      return !!this.ActivesApp?.length;
    },
    SomeTask() {
      return this.Tasks.some(t => !t.done);
    },
    Tasks() {
      const tasks = Object.values(this.tasks ?? {});
      return tasks.sort((a, b) => a.scheduledDate.getTime() - b.scheduledDate.getTime());
    },
    ActiveTasksNow() {
      return !this.ReadonlyMode && this.open && !!this.TasksByExecutionDateGroup.today?.length;
    },
    TasksByExecutionDateGroup() {
      return Object.groupBy(this.Tasks, task => {
        // if ( task.done ) return 'done'

        let scheduledDate = new Date(task.scheduledDate);
        scheduledDate.setHours(0, 0, 0, 0);
        scheduledDate = scheduledDate.getTime();
        if (scheduledDate <= this.today) return 'today';
        return this.$formatDate({
          date: task.scheduledDate,
          format: 'dd/mm/yyyy'
        });
      });
    }
  },
  watch: {
    open() {
      if (this.open) localStorage.setItem('is-autopilot-open', true);else localStorage.removeItem('is-autopilot-open');
    },
    SomeActiveApp() {},
    ActiveTasksNow(enabled) {
      if (enabled && this.$embedded) {
        this.executionTimer.start();
      } else {
        this.executionTimer.stop();
      }
    }
  },
  methods: {
    GetTasksGroupName: function (key) {
      if (key === 'today') return 'Robots para hoy';else if (key === 'done') return 'Robots terminados';
      return key;
    },
    AddAutomation: function (tasks) {
      for (let key in tasks) {
        if (!(key in this.tasks) || this.tasks[key].updatedAt !== tasks[key].updatedAt) {
          this.tasks[key] = tasks[key];
        }
      }
    },
    EnableApp(app) {
      app.enabled = !app.enabled;
      this.UpdateAppLocalStatus();
    },
    UpdateAppLocalStatus() {
      const appLocalStatus = Object.fromEntries(Object.entries(this.apps).map(([key, value]) => [key, {
        enabled: value.enabled,
        certificates: value.certificates
      }]));
      this.$userLocalStorage.set('autopilot-appLocalStatus', JSON.stringify(appLocalStatus));
    },
    AddCertificate: function (app) {
      this.modalSlots.certificate = {
        title: app.title,
        text: 'Selecciona un certificado para la automatización del proceso',
        headerIcon: {
          class: 'icon-previous text-xl hover:-translate-x-0.5 transition-transform',
          onclick: () => this.modalSlots.activeSlot = 'modal'
        },
        footer: [{
          variant: 'outlined',
          text: this.$st('general.back'),
          onclick: () => this.modalSlots.activeSlot = 'modal'
        }, {
          text: this.$st('general.add'),
          onclick: () => {
            this.AddCertificatesToApp();
            this.modalSlots.activeSlot = 'modal';
          }
        }]
      };
      this.modalSlots.activeSlot = 'certificate';
      this.modalSlots.selectedApp = app;
    },
    DeleteCertificate: function (app, certNumeber) {
      let index = app.certificates.indexOf(certNumeber);
      if (index !== -1) {
        app.normalizedCertificates.splice(index, 1);
        app.certificates.splice(index, 1);
      }
      this.UpdateAppLocalStatus();
    },
    LaunchNextActiveTask: async function () {
      const nextTask = this.TasksByExecutionDateGroup?.today?.find(task => !task.done && !task.removing && task.app.active);
      if (this.executionInProgress || !nextTask) return;
      if (nextTask.scheduledDate.getTime() <= new Date().getTime()) {
        let externalResolve;
        if (nextTask.app?.timer) nextTask.app.timer.waitForIt = new Promise(r => externalResolve = r);
        nextTask.executionInProgress = this.executionInProgress = true;
        await nextTask.robot?.(nextTask);
        nextTask.executionInProgress = this.executionInProgress = false;
        externalResolve();
        store.state.OnAutopilotExecution?.();
      }
    },
    GetScheduleInterval: function (interval = 'days', every = 1) {
      switch (interval) {
        case 'hours':
          return every === 1 ? 'hora' : 'horas';
        case 'days':
          return every === 1 ? 'día' : 'días';
        case 'months':
          return every === 1 ? 'mes' : 'meses';
      }
    },
    // ==========| Certificates |==========

    AddCertificatesToApp: async function () {
      if (!this.modalSlots.selectedCerts?.length) return;
      const selectedCerts = await UserResourcesManager.methods.GetCertificatesSerialNumber(this.modalSlots.selectedCerts);
      let certificates;
      if (this.modalSlots.selectedApp.certsConfig.multiple && this.modalSlots.selectedApp.certificates?.length) {
        certificates = [...this.modalSlots.selectedApp.certificates];
        selectedCerts.forEach(cert => {
          if (!certificates.includes(cert)) {
            certificates.push(cert);
          }
        });
      } else {
        certificates = selectedCerts;
      }
      this.modalSlots.selectedApp.normalizedCertificates = await UserResourcesManager.methods.SerialNumberToCerts(certificates);
      this.modalSlots.selectedApp.certificates = certificates;
      delete this.modalSlots.selectedCerts;
      this.UpdateAppLocalStatus();
    },
    // ==========| Flows Automation |==========

    UpdatedScheduledDate: function ({
      every,
      interval = 'days',
      scheduledDate
    }) {
      const currentDate = new Date(scheduledDate);
      const now = new Date().getTime();
      while (currentDate.getTime() < now) {
        switch (interval) {
          case 'hours':
            currentDate.setHours(currentDate.getHours() + every);
            break;
          case 'days':
            currentDate.setDate(currentDate.getDate() + every);
            break;
          case 'months':
            currentDate.setMonth(currentDate.getMonth() + every);
            break;
        }
      }
      return currentDate;
    },
    GetFlowSchedules: async function () {
      if (!store.state.currentUser) return;
      this.loading.schedules = true;
      const schedules = [];
      let query;
      if (this.ReadonlyMode) {
        query = `?user=${store.state.currentUser.userData.email}`;
      } else {
        const machineHash = await this.$desktopAppComunication("GetMachineHashCode");
        if (!machineHash) {
          // Avisar de que no tienes máquina
          return;
        }
        query = `?machineHash=${machineHash}&autopilotOpen=${this.open}`;
      }
      let res = await flows.getSchedule(query);
      const newSchedules = [];
      while (res?.status === 200 && res.data.items.length > 0) {
        newSchedules.push(...res.data.items);
        res = await flows.getSchedule(query + (query[0] === '?' ? '&' : '?') + 'start=' + newSchedules.length);
      }
      schedules.push(...newSchedules);
      const normalizedSchedules = Object.fromEntries(schedules.map(schedule => {
        const localCustomProcess = LocalFlows[schedule.localProcess] ?? {};
        const automation = {
          title: schedule.browserFlowName,
          app: this.apps.robots,
          canBeRemoved: true,
          ...schedule,
          scheduledDate: new Date(schedule.scheduledDate),
          info: [{
            text: schedule.user,
            icon: 'icon-user',
            tooltip: `Programado por ${schedule.user}`
          }],
          ...localCustomProcess,
          robot: async scheduleData => {
            const existScheduleResponse = await flows.getScheduleById(scheduleData._id, "?existSchedule=true");
            if (existScheduleResponse.status === 200 && !existScheduleResponse.data) {
              // Schedule has been removed

              delete this.tasks[schedule._id];
              return;
            }
            let response;
            const flowData = {
              flowInputs: schedule.flowInputs,
              flowId: schedule.browserFlow,
              sendOutputToServer: schedule.sendOutputToServer,
              browserFlowSchedule: schedule._id
            };
            if (automation.localFlow) {
              response = await automation.localFlow(flowData);
            } else {
              response = await FlowsController.LaunchFlow(flowData);
            }
            if (response?.status === 299) {
              return;
            }
            if (automation.repeat) {
              const nextScheduledDate = this.UpdatedScheduledDate(automation).toISOString();
              const updateResponse = await flows.updateSchedule(schedule._id, `?scheduledDate=${nextScheduledDate}`);
              if (updateResponse?.status === 200) {
                scheduleData.scheduledDate = new Date(nextScheduledDate);
              }
            } else {
              await this.DeleteFlowSchedule(scheduleData);
            }
            if (automation.automationResponse) automation.automationResponse();
            return response;
          }
        };
        if (this.ReadonlyMode && automation.machine) {
          automation.info.push({
            text: automation.machine.name,
            icon: 'icon-desktop text-lg!',
            tooltip: `Programado para ejecutar en ${automation.machine.name}`
          });
        }
        return [schedule._id, automation];
      }));
      if (this.tasks) {
        // Remove robots schedules if doesn't exist in ddbb

        Object.values(this.tasks).forEach(async task => {
          const hasBeenRemovedInDB = !(task._id in normalizedSchedules);
          const hasBeenUpdated = this.tasks[task._id]?.updatedAt !== task.updatedAt;
          if (!this.$embedded) {
            let logs = await flows.getLogs(`?browserFlowSchedule=${task._id}`);
            if (logs?.status === 200 && logs.data) {
              logs = Object.values(logs.data.items ?? {});
              const taskMs = task.scheduledDate.getTime();
              const log = logs[0]; // Latest log

              if (log && (hasBeenUpdated || new Date(log.createAt).getTime() >= taskMs)) {
                this.AutomationFinishedRemotely(task, log);
              }
            }
          }
          if (hasBeenRemovedInDB) {
            delete this.tasks[task._id];
          }
        });
      }
      this.AddAutomation(normalizedSchedules);
      this.loading.schedules = false;
    },
    AutomationFinishedRemotely: function (task, log) {
      if (log) this.$addRobotLogNotification(log);
      if (task.automationResponse) task.automationResponse();
    },
    DeleteFlowSchedule: async function (task) {
      if (!task?._id) return;
      task.removing = true;
      await flows.deleteSchedule(task._id);
      task.removing = false;
      delete this.tasks[task._id];
    },
    // ==========| Altas y Bajas |==========

    GetAltasBajasForms: async function () {
      const forms = await AltasBajasController.GetForms();
      if (!forms?.length) return;
      const automation = this.tasks[this.apps.altasbajas.automationID];
      const certificates = [...this.apps.altasbajas.normalizedCertificates];
      const submissions = forms.filter(form => !form.processed);
      if (!submissions?.length) return;
      const updateData = data => {
        const data_ = {
          data
        };
        if (data.certificates?.length) {
          data_.info = data.certificates?.map(c => {
            return {
              icon: 'icon-certificate text-lg',
              text: c.subject.CN
            };
          });
        }
        return data_;
      };
      if (!automation) {
        const date = new Date();
        const automation = {
          app: this.apps.altasbajas,
          description: 'Obtener los formularios de Altas y sincronizar con Sistema RED',
          scheduledDate: date,
          ...updateData({
            certificates,
            submissions
          }),
          // items: forms.reduce((acc, form) => { if ( !form.processed && form.lastError !== undefined ) { acc.push({ text: form.title }) } return acc }, []),
          robot: async scheduleData => {
            // eslint-disable-line

            const response = await AltasBajasController.SyncSubmissions({
              flowInputs: scheduleData.data
            });
            delete this.tasks[this.apps.altasbajas.automationID];
            return response;
          }
        };
        this.AddAutomation({
          [this.apps.altasbajas.automationID]: automation
        });
      } else if (!automation.executionInProgress) {
        Object.assign(automation, updateData({
          certificates,
          submissions
        }));
      }
    },
    // ==========| Notifications Automation |==========

    GetNotificationsSchedules: async function (skippedSchedule) {
      if (this.apps.notifications.automationID in this.tasks) return;
      const certificates = [...this.apps.notifications.normalizedCertificates];
      const date = new Date();
      if (skippedSchedule) {
        date.setMinutes(date.getMinutes() + 10);
      }
      const automation = {
        app: this.apps.notifications,
        description: 'Obtener las notificaciones existentes en DEHÚ',
        scheduledDate: date,
        info: certificates?.map(c => {
          return {
            icon: 'icon-certificate text-lg',
            text: c.subject.CN
          };
        }),
        data: {
          certificates
        },
        robot: async scheduleData => {
          // eslint-disable-line

          const response = await NotificationsController.GetNotificationsFromDehu(certificates);
          delete this.tasks[this.apps.notifications.automationID];
          this.GetNotificationsSchedules(true);
          return response;
        }
      };
      this.AddAutomation({
        [this.apps.notifications.automationID]: automation
      });
    }
  }
};